export default __webpack_public_path__ + "static/media/platform-2.bf912ed7.png";